import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfigurations {
  config = {
    name: 'wow',
    title: 'WOW',
    version: '',
    mediaAssetsUrl:environment.mediaAssetsUrl,
    apiUrl: {
      cmsUrl: '',
      backendUrl: environment.backendUrl,
      frontendUrl: '',
    },
    environment: 'staging',
  };

  constructor() {}

  getConfig(): any {
    return this.config;
  }
}
